import dataAnalyticsMock from './__mocks__';

// just use the mock until we actually consume PHDAPI
export default dataAnalyticsMock;
